import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  Form,
  Row,
  Col, 
  Container,
  Table,
  Modal,
  Card,
  Image,
  Collapse,
} from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Outlet, NavLink } from 'react-router-dom';
import { colors, initialAlert } from "../configs";
import { useSelector, useDispatch } from "react-redux";
import '../styles/Restaurant.css'
import { addShopId, logout } from "../redux/authSlice";
import { Modal_Alert, Modal_FlatListTwoColumn } from "../modal";
import { Dropdown, Accordion } from 'rsuite';
import { transformData } from "../Utility/function";
import { RootImage } from "../components";
import { updateBackToHome } from "../redux/deviceSlice";
import { clearBill } from "../redux/billSlice";
import { clearCheckIn } from "../redux/checkInSlice";
import { clearInbound } from "../redux/inboundSlice";
import { clearMember } from "../redux/memberSlice";
import { clearShift } from "../redux/shiftSlice";
import { clearRequisition } from "../redux/requisitionSlice";
import { db } from "../db/firestore";
import { fetchNormalShop } from "../redux/shopSlice";

const { white, purpleRed, softWhite, backgroundColor, dark } = colors;

const sidebars = [
  {
      label: '1. ภาพรวมธุรกิจ',
  },
  {
      topic: '1.1 แดชบอร์ด',
      to:'dashboard',
      premium:false,
  },
  {
      topic: '1.2 ยอดขายรายวัน',
      to:'reportDaily',
      premium:false,
  },
  {
      topic: '1.3 ยอดขายตามสินค้า',
      to:'item',
      premium:false,
  },
  {
      topic: '1.4 ยอดขายตามสินค้าฝากขาย',
      to:'consigment',
      premium:false,
  },
  {
      topic: '1.5 ยอดขายตามหมวดหมู่',
      to:'reportCategory',
      premium:false,
  },
  {
      topic: '1.6 ยอดขายตามช่องทางชำระเงิน',
      to:'reportPayment',
      premium:false,
  },
  {
      label: '2. แนวโน้ม',
  },
  {
      topic: '2.1 แนวโน้มยอดขาย',
      to:'trendSale',
      premium:true,
  },
  {
      topic: '2.2 แนวโน้มยอดขายตามหมวดหมู่',
      to:'trendCategory',
      premium:true,
  },
  {
      topic: '2.3 แนวโน้มยอดขายตามช่องทางชำระเงิน',
      to:'trendPayment',
      premium:true,
  },
  {
      topic: '2.4 แนวโน้มยอดขายตามสินค้า',
      to:'trendProduct',
      premium:true,
  },
  {
      topic: '2.5 แนวโน้มยอดขายตามส่วนลด/โปรโมชั่น',
      to:'trendDiscount',
      premium:true,
  },
  {
      topic: '2.6 เปรียบเทียบยอดขายตามหมวดหมู่',
      to:'compareCategory',
      premium:true,
  },
  
  {
      label: '3. รายงานรับสินค้า',
  },
  {
      topic: '3.1 ประวัติ',
      to:'inbound',
      premium:false,
  },
  {
      topic: '3.2 รายงานสินค้า',
      to:'inboundItem',
      premium:false,
  },
  {
      topic: '3.3 รายงานคู่ค้า',
      to:'inboundVender',
      premium:false,
  },
  {
      label: '4. ใบเสร็จ',
  },
  
  {
      topic: '4.1 ข้อมูลใบเสร็จ',
      to: 'reportBill',
      premium:false,
  },
  {
      topic: '4.2 กะ',
      to: 'reportShift',
      premium:false,
  },
  {
      topic: '4.3 รายงานภาษีขาย',
      to: 'reportVat',
      premium:true,
  },

  {
      label: '5. พนักงาน',
  },
  {
      topic: '5.1 รายงานเวลาทำงาน',
      to: 'reportCheckIn',
  },
  {
      label: '6. สมาชิก',
  },
  {
      topic: '6.1 อัปโหลดสมาชิก',
      to: 'uploadMember',
  },
  {
      topic: '6.2 สมาชิก',
      to: 'member',
  },
  {
    label: '7. แพ็กเกจของฉัน',
  },
  {
      topic: '7.1 จัดการแพ็กเกจ',
      to: 'package',
  },
  {
    label: '8. เพิ่มเติม',
  },
  {
    topic: '8.1 เบิกสินค้า',
    to: 'requisition',
},
  {
      label: 'ออกจากระบบ',
  },
]


function MasterScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [alert_Modal, setAlert_Modal] = useState(initialAlert);
  const { status, content, onClick, variant } = alert_Modal;
  const { shop:{ logo = '', name:shopName }, premiumEnable, shopFranchises } = useSelector(state=>state.shop);
  const [short, setShort] = useState(false); // คือการย่อแถบข้าง
  const [listDisplay, setListDisplay] = useState([]);
  const [franchise_Modal, setFranchise_Modal] = useState(false);

  useEffect(() => {  // เอาไว้กำหนด display ของ sidebar
    // Function to update the window width state
   
    setListDisplay(transformData(sidebars.filter(a=>a.label!=='ออกจากระบบ')))

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Event listener to update the window width state on resize
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


    function exit(){
      dispatch(logout()).then(()=>{
        navigate('/')
      })
    };

  
    function backToList(){
      Promise.all([
        dispatch(updateBackToHome(true)),
        navigate('/shopList'),
        dispatch(clearBill()),
        dispatch(clearCheckIn()),
        dispatch(clearInbound()),
        dispatch(clearMember()),
        dispatch(clearShift()),
        dispatch(clearRequisition())
      ])
    };

        const { franchiseDisplay } = useSelector(state=>state.auth);

    async function handleFranchise(value){
      setFranchise_Modal(false)
        const shopDoc = await db.collection('shop').doc(value.id).get();
        const shopData = {
            ...shopDoc.data(),
            id:shopDoc.id,
          
        }
      Promise.all([
        dispatch(addShopId({
          currentShopId:value.id,
          franchiseDisplay:true
        })),
        dispatch(fetchNormalShop(shopData)),
        dispatch(clearBill()),
        dispatch(clearShift()),
      ])
  };
  
  return (
    <div style={{backgroundColor:colors.backgroundColor}} >
      <Modal_FlatListTwoColumn
            show={franchise_Modal}
            header='เลือกสาขา'
            onHide={()=>{setFranchise_Modal(false)}}
            onClick={handleFranchise}
            value={shopFranchises}
            searchKey={['name']}
            thisKey={["name"]}
            placeholder="ค้นหาด้วยชื่อสาขา"
      />
        <Modal_Alert
            show={status}
            onHide={()=>{setAlert_Modal(initialAlert)}}
            content={content}
            onClick={onClick}
            variant={variant}
        />
        {windowWidth < 576 || short || franchiseDisplay
                ?<div>
                  
                  <div style={styles.container} >
                         {franchiseDisplay
                              ?<Button variant="dark" style={{position:'absolute',top:15,right:10, borderRadius:100, cursor:'pointer'}} onClick={()=>{window.location.reload()}} ><i class="bi bi-arrow-clockwise"></i></Button>
                              :<Button variant="dark" style={{position:'absolute',top:15,right:10, borderRadius:100, cursor:'pointer'}} onClick={backToList} ><i class="bi bi-houses-fill"></i></Button>
                          }

                      
                      
                      <div style={styles.container2} >
                      {/* <h6>ร้าน : {shopName}</h6> */}
                        <Dropdown title="&emsp;&emsp;&emsp;เมนู&emsp;&emsp;&emsp;" trigger='click' style={styles.container3}  >
                            <Accordion style={{minWidth:'200px'}} defaultActiveKey={0}  >
                              {listDisplay.map((item,index)=>{
                                const { topic, value,  } = item;

                                return <Accordion.Panel key={index} header={topic} eventKey={index+1}  >
                                          {value.map((a)=>{
                                            const { id, name, to, premium } = a
                                            const text = premium?`⭐${name}`:name
                                            return <Dropdown.Item key={id} onClick={()=>{
                                              if (premium && !premiumEnable) {
                                                setAlert_Modal({
                                                  status:true,
                                                  content:`สมัครแพ็กเกจพรีเมี่ยม เพื่อใช้งานข้อมูลได้ไม่จำกัด`,
                                                  onClick:()=>{navigate('/master/package')},
                                                  variant:'success'
                                                })
                                              } else {
                                                navigate(to)
                                              }
                                              }}  >
                                                {text}
                                                </Dropdown.Item>
                                          })}
                                      </Accordion.Panel>
                              })}
                            </Accordion>
                            <Dropdown.Item onClick={() => {
                              setAlert_Modal({
                                status:true,
                                content:`ยืนยันการออกจากระบบ`,
                                onClick:()=>{exit();setAlert_Modal(initialAlert)},
                                variant:'danger'
                              })
                            }} >&emsp;<i class="bi bi-box-arrow-left"></i>&emsp;ออกจากระบบ</Dropdown.Item>
                        </Dropdown>
                          {franchiseDisplay
                            ?<Button onClick={()=>{setFranchise_Modal(true)}} variant="success" appearance="ghost"style={{minWidth:'200px',margin:'10px',fontSize:16, maxWidth:'400px'}} >{shopName}</Button>
                            :null
                          }
                      </div>
                      {/* <div onClick={()=>{setShort(false)}} style={styles.container4} > 
                        <i class="bi bi-list"></i>
                      </div> */}
                  </div>
                  {windowWidth < 900
                      ?<br/>
                      :null
                  }
                  
                  <div style={styles.container5}>
                      <Outlet />
                  </div> 
                </div>
                :<div>
                  {franchiseDisplay
                      ?<Row style={{position:'sticky',top:0,zIndex:999,backgroundColor:white}} >
                        &emsp;<Button onClick={()=>{setFranchise_Modal(true)}} variant="success" appearance="ghost"style={{minWidth:'350px',margin:'10px',fontSize:16, maxWidth:'400px'}} >{shopName}</Button>
                      </Row>
                      :null
                    }
                <div style={styles.container7}>
                    <div style={styles.container8} >
                      <div onClick={()=>{setShort(true)}} style={styles.container9} > 
                        <i class="bi bi-list"></i>
                      </div>
                      {logo
                          ?<img style={styles.container10} src={logo}/>
                          :<RootImage style={styles.container10} />
                      }
                      <Button variant="dark" style={{position:'absolute',top:50,left:5, borderRadius:100}} onClick={backToList} ><i class="bi bi-houses-fill"></i></Button>
                      
                    </div>
                      <div style={styles.container11}>
                        <div className="resSidebar">
                          {sidebars.map((item, index) => (
                              <React.Fragment key={index}>
                              {item.label && (
                                  <div
                                  style={styles.container12}
                                  >
                                  {item.label}
                                  </div>
                              )}
                              {item.to && (
                                  <NavLink
                                  exact
                                  to={item.to}
                                  // activeClassName='resSidebar a.active'
                                  // onMouseEnter={() => handleMouseEnter(index)}
                                  // onMouseLeave={handleMouseLeave}
                                  onClick={(e) => {
                                    if (item.premium && !premiumEnable) {
                                      e.preventDefault(); // Stop navigation
                                      setAlert_Modal({
                                        status:true,
                                        content:`สมัครแพ็กเกจพรีเมี่ยม เพื่อใช้งานข้อมูลได้ไม่จำกัด`,
                                        onClick:()=>{navigate('/master/package')},
                                        variant:'success'
                                      })
                                    } else {
                                      console.log('Navigating to', item.to);
                                      // Do other logic if needed
                                    }
                                  }}
                                  >
                                    {item.premium
                                      ?<i class="bi bi-star-fill"></i>
                                      :null
                                    }
                                    
                                  {item.topic}
                                  </NavLink>
                              )}
                              </React.Fragment>
                          ))}
                        </div>
                        <div style={{display:'flex',justifyContent:'center',color:white,backgroundColor:dark,padding:10,cursor:'pointer'}} onClick={()=>{setAlert_Modal({ ...initialAlert,status:true, content:`ยืนยัน ออกจากระบบ`, onClick:()=>{exit()}, variant:'danger' })}} >
                          Logout
                        </div>
                      </div>
                     
              </div> 
              <div style={{width:windowWidth < 576 || short ? '100%' : 'calc(100% - 212px)', marginLeft: windowWidth < 576 ? 0 : '210px',backgroundColor:backgroundColor, height:'100%'}}>
                <Outlet />
            </div>
              </div>
            }
        
    </div>
  );
};

const styles = {
  container : {
    paddingTop:'1rem',paddingBottom:'1rem',backgroundColor:softWhite,width:'100%',display:'flex',paddingRight:'3rem',position:'fixed',top:0,backgroundColor:white,zIndex:99
  },
  container2 : {
    maxWidth:'80vw', whiteSpace: 'nowrap', scrollbarWidth:'thin',zIndex:999,marginLeft:'3rem'
  },
  container3 : {
    paddingLeft:'5px',paddingRight:'5px'
  },
  container4 : {
    position:'absolute',top:10,left:10,fontSize:30,cursor:'pointer'
  },
  container5 : {
    width:'100%',paddingTop:'5rem',backgroundColor:backgroundColor, height:'100%',marginLeft:'1rem'
  },
  container6 : {
    minWidth:'150px'
  },
  container7 : {
    width: '200px', minWidth: '200px', position: 'fixed',backgroundColor:'#343333'
  },
  container8 : {
    display:'flex',justifyContent:'center'
  },
  container9 : {
    position:'absolute',top:10,left:10,color:white,fontSize:30,cursor:'pointer'
  },
  container10 : {
    width:'100px',height:'100px',backgroundColor:'#343333',borderRadius:'100px',objectFit:'cover'
  },
  container11 : {
    maxHeight: '100vh', overflowY: 'auto',paddingBottom:'6rem'
  },
  container12 : {
    width: '100%',fontWeight: 'bold',fontSize: 12,
  },
  container13 : {
    backgroundColor: purpleRed,
    color: white,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 20,
    marginLeft: 5,
  }

}

export default MasterScreen;